import { catalog } from './catalog'
import type { SupportedLanguage } from './routes'

type LocalizedMessage = Record<SupportedLanguage, string>

export const uiMessages = {
  "shell.staffArea": { it: "Area riservata", en: "Staff area" },
  "hero.contactEyebrow": {"it": "Parliamo della tua prossima auto", "en": "Let’s talk about your next car"},

  "hero.sellEyebrow": {"it": "Valutazione del veicolo", "en": "Vehicle valuation"},

  "sell.nextBody": {"it": "Esaminiamo le informazioni e ti contattiamo per conoscere meglio il veicolo. La valutazione definitiva viene concordata dopo la verifica dell’auto.", "en": "We review your information and contact you to learn more about the vehicle. The final valuation is agreed after inspecting the car."},

  "sell.nextTitle": {"it": "Come proseguiamo", "en": "What happens next"},

  "sell.automatic": {"it": "Automatico", "en": "Automatic"},

  "sell.manual": {"it": "Manuale", "en": "Manual"},

  "sell.other": {"it": "Altro", "en": "Other"},

  "sell.methane": {"it": "Metano", "en": "CNG"},

  "sell.lpg": {"it": "GPL", "en": "LPG"},

  "sell.electric": {"it": "Elettrica", "en": "Electric"},

  "sell.hybrid": {"it": "Ibrida", "en": "Hybrid"},

  "sell.diesel": {"it": "Diesel", "en": "Diesel"},

  "sell.petrol": {"it": "Benzina", "en": "Petrol"},

  "sell.choose": {"it": "Seleziona", "en": "Select"},

  "sell.invalidNumber": {"it": "Inserisci un valore valido.", "en": "Enter a valid value."},

  "sell.required": {"it": "Compila questo campo.", "en": "Complete this field."},

  "sell.success": {"it": "Richiesta inviata. Ti ricontatteremo per la valutazione della tua auto.", "en": "Request sent. We will contact you about your car’s valuation."},

  "sell.submit": {"it": "Richiedi valutazione", "en": "Request valuation"},

  "sell.notes": {"it": "Note e informazioni aggiuntive (facoltativo)", "en": "Notes and additional information (optional)"},

  "sell.phone": {"it": "Telefono", "en": "Phone"},

  "sell.address": {"it": "Indirizzo (facoltativo)", "en": "Address (optional)"},

  "sell.city": {"it": "Comune", "en": "Town / city"},

  "sell.province": {"it": "Provincia", "en": "Province / region"},

  "sell.lastName": {"it": "Cognome", "en": "Last name"},

  "sell.firstName": {"it": "Nome", "en": "First name"},

  "sell.price": {"it": "Prezzo richiesto (€)", "en": "Asking price (€)"},

  "sell.condition": {"it": "Condizioni del veicolo", "en": "Vehicle condition"},

  "sell.interior": {"it": "Colore interno", "en": "Interior colour"},

  "sell.color": {"it": "Colore esterno", "en": "Exterior colour"},

  "sell.doors": {"it": "Porte", "en": "Doors"},

  "sell.power": {"it": "Potenza (CV)", "en": "Power (hp)"},

  "sell.engine": {"it": "Cilindrata (cc)", "en": "Engine size (cc)"},

  "sell.gearbox": {"it": "Cambio", "en": "Transmission"},

  "sell.fuel": {"it": "Alimentazione", "en": "Fuel type"},

  "sell.plate": {"it": "Targa", "en": "Registration plate"},

  "sell.mileage": {"it": "Chilometraggio (km)", "en": "Mileage (km)"},

  "sell.year": {"it": "Anno di immatricolazione", "en": "Registration year"},

  "sell.version": {"it": "Versione", "en": "Version"},

  "sell.model": {"it": "Modello", "en": "Model"},

  "sell.make": {"it": "Marca", "en": "Make"},

  "sell.optional": {"it": "Questi dettagli sono facoltativi, ma ci aiutano a valutare il veicolo.", "en": "These details are optional, but help us value your vehicle."},

  "sell.contactTitle": {"it": "I tuoi recapiti", "en": "Your contact details"},

  "sell.detailsTitle": {"it": "Caratteristiche e condizioni", "en": "Features and condition"},

  "sell.vehicleTitle": {"it": "La tua auto", "en": "Your car"},

  "sell.formIntro": {"it": "Partiamo dai dati della tua auto. Ti ricontatteremo per approfondire le condizioni e valutare insieme vendita o permuta.", "en": "Start with your car’s details. We will contact you to discuss its condition and explore a sale or trade-in."},

  "sell.formTitle": {"it": "Richiedi una valutazione", "en": "Request a valuation"},

  "sell.intro": {"it": "Inserisci i dati della tua auto e richiedi una valutazione.", "en": "Enter your car’s details and request a valuation."},

  "sell.title": {"it": "Vendi la tua auto.", "en": "Sell your car."},

  "contact.mapTitle": {"it": "Dove siamo", "en": "Find us"},

  "contact.saturdayHours": {"it": "8:30–13:00 / 14:30–18:30", "en": "8:30 am–1 pm / 2:30–6:30 pm"},

  "contact.weekdayHours": {"it": "8:30–13:00 / 15:00–19:30", "en": "8:30 am–1 pm / 3–7:30 pm"},

  "contact.saturday": {"it": "Sabato", "en": "Saturday"},

  "contact.weekdays": {"it": "Lunedì – venerdì", "en": "Monday – Friday"},

  "contact.hours": {"it": "Orari di apertura", "en": "Opening hours"},

  "contact.phone": {"it": "Telefono", "en": "Phone"},

  "contact.address": {"it": "Indirizzo", "en": "Address"},

  'nav.home': catalog.nav.home,
  'nav.services': catalog.nav.services,
  'nav.vehicles': catalog.nav.vehicles,
  'nav.sellVehicle': catalog.nav.sellVehicle,
  'nav.contacts': catalog.nav.contacts,
  'nav.shortRental': { it: 'Noleggio breve', en: 'Short-term rental' },
  'nav.booking': { it: 'Prenotazione', en: 'Booking' },
  'nav.faq': { it: 'Domande frequenti', en: 'Frequently asked questions' },
  'nav.privacy': catalog.common.privacy,
  'nav.vehicle': { it: 'Dettaglio veicolo', en: 'Vehicle details' },
  'common.skipToContent': catalog.common.skipToContent,
  'common.close': catalog.common.close,
  'common.menu': catalog.common.menu,
  'common.privacy': catalog.common.privacy,
  'common.openMenu': { it: 'Apri il menu', en: 'Open menu' },
  'common.closeMenu': { it: 'Chiudi il menu', en: 'Close menu' },
  'common.notAvailable': { it: 'Contenuto in preparazione', en: 'Content in preparation' },
  'brand.homeLabel': { it: 'TS Auto, pagina iniziale', en: 'TS Auto, home page' },
  'shell.menuTitle': { it: 'Navigazione', en: 'Navigation' },
  'shell.menuDescription': {
    it: 'Scegli una sezione del sito.',
    en: 'Choose a section of the website.',
  },
  'shell.languageSelectorLabel': { it: 'Seleziona lingua', en: 'Select language' },
  'shell.languageItalian': { it: 'Italiano', en: 'Italiano' },
  'shell.languageItalianShort': { it: 'IT', en: 'IT' },
  'shell.languageEnglish': { it: 'English', en: 'English' },
  'shell.languageEnglishShort': { it: 'EN', en: 'EN' },
  'shell.footerIntro': {
    it: 'TS Auto seleziona auto usate certificate e controllate e offre noleggio, intermediazione e conto vendita. Con partner affidabili e finanziamenti dedicati, garantiamo trasparenza, sicurezza e supporto nella scelta dell’auto ideale.',
    en: 'TS Auto selects certified, inspected used cars and offers rental, brokerage and consignment services. With trusted partners and tailored financing, we provide transparency, safety and support in choosing the right car.',
  },
  'shell.footerNavigation': {
    it: 'Navigazione',
    en: 'Navigation',
  },
  'shell.footerNavigationLabel': {
    it: 'Navigazione footer',
    en: 'Footer navigation',
  },
  'shell.footerContacts': {
    it: 'Contatti diretti',
    en: 'Direct contacts',
  },
  'shell.footerCopyright': {
    it: '© {{year}} TS Auto. Tutti i diritti riservati.',
    en: '© {{year}} TS Auto. All rights reserved.',
  },
  'shell.draftLanguage': {
    it: 'Italiano approvato',
    en: 'English draft — not approved for publication',
  },
  'sandbox.kicker': { it: 'Fondazioni visive', en: 'Visual foundations' },
  'sandbox.title': {
    it: 'Chiarezza da showroom. Precisione da scheda tecnica.',
    en: 'Showroom clarity. Technical-sheet precision.',
  },
  'sandbox.intro': {
    it: 'Questa pagina verifica la shell e i componenti condivisi. Non è la home definitiva.',
    en: 'This page verifies the shared shell and components. It is not the final home page.',
  },
  'sandbox.primaryAction': { it: 'Esplora i veicoli', en: 'Explore vehicles' },
  'sandbox.secondaryAction': { it: 'Parla con noi', en: 'Talk to us' },
  'sandbox.verification': { it: 'Informazioni verificabili', en: 'Verifiable information' },
  'sandbox.typeLabel': { it: 'Gerarchia e dati', en: 'Hierarchy and data' },
  'sandbox.typeTitle': { it: 'Inter dà forma ai dati.', en: 'Inter shapes the data.' },
  'sandbox.typeBody': {
    it: 'Open Sans mantiene chiari testi, controlli e navigazione anche nelle misure più compatte.',
    en: 'Open Sans keeps text, controls and navigation clear, even at compact sizes.',
  },
  'sandbox.gridToken': { it: 'Griglia', en: 'Grid' },
  'sandbox.rhythmToken': { it: 'Ritmo', en: 'Rhythm' },
  'sandbox.readingToken': { it: 'Lettura', en: 'Reading' },
  'sandbox.controlsLabel': { it: 'Controlli', en: 'Controls' },
  'sandbox.controlsTitle': { it: 'Azioni riconoscibili in ogni stato', en: 'Recognisable actions in every state' },
  'sandbox.buttonDefault': { it: 'Azione primaria', en: 'Primary action' },
  'sandbox.buttonSecondary': { it: 'Azione secondaria', en: 'Secondary action' },
  'sandbox.buttonLoading': { it: 'Caricamento', en: 'Loading' },
  'sandbox.buttonDisabled': { it: 'Non disponibile', en: 'Unavailable' },
  'sandbox.linkDisabled': { it: 'Link non disponibile', en: 'Unavailable link' },
  'sandbox.disabledLabel': { it: 'Campo non modificabile', en: 'Read-only field' },
  'sandbox.disabledValue': { it: 'Dato bloccato', en: 'Locked data' },
  'sandbox.nameLabel': { it: 'Nome e cognome', en: 'Full name' },
  'sandbox.nameHint': { it: 'Come possiamo chiamarti.', en: 'How we can address you.' },
  'sandbox.emailLabel': { it: 'Email', en: 'Email' },
  'sandbox.emailError': { it: 'Inserisci un indirizzo email valido.', en: 'Enter a valid email address.' },
  'sandbox.dialogAction': { it: 'Apri dialogo', en: 'Open dialog' },
  'sandbox.sheetAction': { it: 'Apri pannello', en: 'Open panel' },
  'sandbox.dialogTitle': { it: 'Richiesta informazioni', en: 'Information request' },
  'sandbox.dialogDescription': {
    it: 'Il focus resta nel dialogo finché non lo chiudi.',
    en: 'Focus stays in the dialog until you close it.',
  },
  'sandbox.dialogConfirm': { it: 'Ho capito', en: 'Got it' },
  'sandbox.sheetTitle': { it: 'Filtri veicoli', en: 'Vehicle filters' },
  'sandbox.sheetDescription': {
    it: 'Il pannello mobile usa lo stesso contratto accessibile del menu.',
    en: 'The mobile panel uses the same accessible contract as the menu.',
  },
  'sandbox.statesLabel': { it: 'Stati di sistema', en: 'System states' },
  'sandbox.statesTitle': { it: 'Ogni esito indica il passo successivo', en: 'Every outcome shows the next step' },
  'sandbox.cardReadyTitle': { it: 'Dati pronti', en: 'Data ready' },
  'sandbox.cardReadyBody': {
    it: 'Le informazioni disponibili sono ordinate e leggibili.',
    en: 'Available information is ordered and legible.',
  },
  'sandbox.cardEmptyTitle': { it: 'Nessun risultato', en: 'No results' },
  'sandbox.cardEmptyBody': {
    it: 'Modifica i criteri o azzera i filtri.',
    en: 'Change your criteria or reset the filters.',
  },
  'sandbox.cardErrorTitle': { it: 'Caricamento interrotto', en: 'Loading interrupted' },
  'sandbox.cardErrorBody': {
    it: 'Riprova. Se il problema continua, contattaci direttamente.',
    en: 'Try again. If the problem continues, contact us directly.',
  },
  'sandbox.statusReady': { it: 'Pronto', en: 'Ready' },
  'sandbox.statusEmpty': { it: 'Vuoto', en: 'Empty' },
  'sandbox.statusError': { it: 'Errore', en: 'Error' },
  'sandbox.routePlaceholder': {
    it: 'La pagina definitiva sarà realizzata nella sezione dedicata del refactor.',
    en: 'The final page will be built in its dedicated refactor section.',
  },
  'sandbox.backToFoundation': { it: 'Torna alle fondazioni', en: 'Back to foundations' },
  'privacy.contentLabel': { it: 'Informazioni sul trattamento dei dati personali', en: 'Personal data processing information' },
  'privacy.controllerBody': {
    it: 'Il titolare del trattamento è TS Auto. Per domande relative alla privacy puoi scrivere a',
    en: 'The data controller is TS Auto. For privacy-related questions, you can write to',
  },
  'privacy.controllerTitle': { it: 'Titolare del trattamento', en: 'Data controller' },
  'privacy.dataBody': {
    it: 'Raccogliamo i dati che scegli di inviarci tramite i moduli del sito, come nome, email, telefono, messaggio ed eventuali informazioni sul veicolo.',
    en: 'We collect the data you choose to send through the website forms, such as your name, email, phone number, message and any vehicle information.',
  },
  'privacy.dataTitle': { it: 'Dati raccolti', en: 'Data we collect' },
  'privacy.eyebrow': { it: 'Trasparenza e dati personali', en: 'Transparency and personal data' },
  'privacy.intro': {
    it: 'Questa informativa descrive in modo semplice come trattiamo i dati personali inviati attraverso il sito.',
    en: 'This notice explains in simple terms how we process personal data submitted through the website.',
  },
  'privacy.purposeBody': {
    it: 'Utilizziamo i dati per rispondere alle richieste, fornire informazioni sui veicoli e sui servizi e gestire i contatti con gli interessati.',
    en: 'We use the data to answer enquiries, provide information about vehicles and services, and manage contact with interested customers.',
  },
  'privacy.purposeTitle': { it: 'Finalità del trattamento', en: 'Why we use your data' },
  'privacy.retentionBody': {
    it: 'Conserviamo i dati solo per il tempo necessario a gestire la richiesta e per gli eventuali obblighi previsti dalla legge, adottando misure adeguate per proteggerli.',
    en: 'We keep data only for as long as needed to handle the enquiry and meet any legal obligations, using appropriate measures to protect it.',
  },
  'privacy.retentionTitle': { it: 'Conservazione e sicurezza', en: 'Retention and security' },
  'privacy.rightsBody': {
    it: 'Puoi chiedere l’accesso, la rettifica o la cancellazione dei tuoi dati e, nei casi previsti, limitarne il trattamento o opporti. Per esercitare i tuoi diritti scrivi a',
    en: 'You may request access to, correction or deletion of your data and, where applicable, restrict or object to its processing. To exercise your rights, write to',
  },
  'privacy.rightsTitle': { it: 'I tuoi diritti', en: 'Your rights' },
  'privacy.title': { it: 'Informativa privacy', en: 'Privacy notice' },
  'seo.contactMetadataDescription': {
    it: 'Invia una richiesta a TS Auto: disponibilità e condizioni vengono confermate dalla sede.',
    en: 'Send an enquiry to TS Auto: availability and terms are confirmed by the dealership.',
  },
  'seo.contactMetadataTitle': { it: 'Contatti — TS Auto', en: 'Contact — TS Auto' },
  'seo.privacyMetadataDescription': {
    it: 'Informazioni sul trattamento dei dati personali inviati attraverso il sito TS Auto.',
    en: 'Information about the processing of personal data submitted through the TS Auto website.',
  },
  'seo.privacyMetadataTitle': { it: 'Informativa privacy — TS Auto', en: 'Privacy notice — TS Auto' },
  'seo.placeholderMetadataDescription': {
    it: 'Il contenuto definitivo non è ancora disponibile.',
    en: 'The final content is not available yet.',
  },
  'seo.placeholderMetadataTitle': { it: 'Contenuto in preparazione — TS Auto', en: 'Content in preparation — TS Auto' },
  'error.title': { it: 'Questa parte non si è caricata', en: 'This part did not load' },
  'error.body': {
    it: 'Ricarica la pagina. Se il problema continua, torna alla pagina iniziale.',
    en: 'Reload the page. If the problem continues, return to the start page.',
  },
  'error.reload': { it: 'Ricarica la pagina', en: 'Reload page' },
  'contact.title': { it: 'Contatti.', en: 'Contact us.' },
  "contact.intro": {"it": "Vieni a trovarci, chiamaci o scrivici. Ti aiutiamo a scegliere la tua prossima auto.", "en": "Visit us, call or write to us. We will help you choose your next car."},
  "contact.officeTitle": {"it": "Vieni a trovarci", "en": "Visit our dealership"},
  'contact.locationLabel': { it: 'Località', en: 'Location' },
  'contact.directDetailsTitle': { it: 'Recapiti diretti', en: 'Direct contact details' },
  'contact.directDetailsMissing': {
    it: 'Invia una richiesta per ricevere recapiti, orari e indicazioni aggiornate.',
    en: 'Send an enquiry to receive current contact details, opening hours and directions.',
  },
  'contact.formTitle': { it: 'Invia una richiesta', en: 'Send an enquiry' },
  'contact.formIntro': {
    it: 'I campi contrassegnati sono necessari per preparare la richiesta.',
    en: 'Marked fields are needed to prepare your enquiry.',
  },
  'contact.nameLabel': { it: 'Nome e cognome', en: 'Full name' },
  'contact.emailLabel': { it: 'Email', en: 'Email' },
  'contact.phoneLabel': { it: 'Telefono (facoltativo)', en: 'Phone (optional)' },
  'contact.phoneHint': { it: 'Usa solo numeri, con + iniziale se necessario.', en: 'Use digits only, with a leading + if needed.' },
  'contact.vehicleLabel': { it: 'Veicolo di riferimento (facoltativo)', en: 'Vehicle reference (optional)' },
  'contact.messageLabel': { it: 'Come possiamo aiutarti?', en: 'How can we help?' },
  'contact.privacyLabel': { it: 'Ho letto l’informativa privacy.', en: 'I have read the privacy notice.' },
  'contact.privacyLink': { it: 'Leggi l’informativa privacy', en: 'Read the privacy notice' },
  'contact.submit': { it: 'Invia richiesta', en: 'Send enquiry' },
  'contact.sending': { it: 'Invio in corso', en: 'Sending' },
  'contact.errorSummary': { it: 'Controlla i campi indicati.', en: 'Check the marked fields.' },
  'contact.errorName': { it: 'Inserisci nome e cognome.', en: 'Enter your full name.' },
  'contact.errorEmail': { it: 'Inserisci un indirizzo email valido.', en: 'Enter a valid email address.' },
  'contact.errorPhone': { it: 'Inserisci solo numeri e, se serve, un + iniziale.', en: 'Use digits only and, if needed, a leading +.' },
  'contact.errorMessage': { it: 'Scrivi una richiesta tra 1 e 10.000 caratteri.', en: 'Write an enquiry between 1 and 10,000 characters.' },
  'contact.errorPrivacy': { it: 'Leggi e conferma l’informativa privacy.', en: 'Read and confirm the privacy notice.' },
  'contact.submitError': {
    it: 'La richiesta non è stata inviata. Riprova più tardi.',
    en: 'The enquiry was not sent. Please try again later.',
  },
  'contact.liveSuccess': {
    it: 'Richiesta inviata. La sede verificherà disponibilità e condizioni.',
    en: 'Enquiry sent. The dealership will confirm availability and terms.',
  },
  'contact.chatTitle': { it: 'Assistente virtuale', en: 'Virtual assistant' },
  'contact.chatSubtitle': { it: 'TS Auto', en: 'TS Auto' },
  'contact.chatWelcome': {
    it: 'Ciao, come posso aiutarti a trovare la tua prossima auto?',
    en: 'Hello, how can I help you find your next car?',
  },
  'contact.chatOpen': { it: 'Apri assistente virtuale', en: 'Open virtual assistant' },
  'contact.chatClose': { it: 'Chiudi assistente virtuale', en: 'Close virtual assistant' },
  'contact.chatPrompt': { it: 'Scrivi una domanda', en: 'Write a question' },
  'contact.chatSend': { it: 'Invia domanda', en: 'Send question' },
  'contact.chatUnavailable': { it: 'L’assistente non è disponibile.', en: 'The assistant is unavailable.' },
} as const satisfies Record<string, LocalizedMessage>

export type UiMessageKey = keyof typeof uiMessages
